import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import * as Middleware from "@middlewares/index";

const HowToUseNoAuth: React.FC = () => {
  const renderDesc = () => {
    return (
      <div className="modal__desc">
        Здесь Вы можете найти новых партнеров для работы и бизнеса!
      </div>
    );
  };

  const netwDays = useSelector((state) => state.Networking?.Days.data);

  return (
    <div className="modal-wrap">
      <button
        className="modal__close"
        onClick={() => {
          Middleware.Ui.Modal.close();
        }}
      />
      <div className="modal modal--content modal--use-no-auth">
        <div className="col-left">
          <div className="modal__header">
            <div className="modal__title">
              Добро пожаловать в систему Нетворкинга!
            </div>
          </div>
          <div className="modal__body">
            {renderDesc()}
            <ul className="steps-netw">
              <li className="steps-netw__item">
                <span>Шаг 1:</span> Чтобы воспользоваться всеми функциями,{" "}
                <Link
                  to="/auth/signin"
                  onClick={() => {
                    Middleware.Ui.Modal.close();
                  }}
                >
                  Войдите
                </Link>{" "}
                или{" "}
                <Link
                  onClick={() => {
                    Middleware.Ui.Modal.close();
                  }}
                  to="/auth/signup"
                >
                  Зарегистрируйтесь
                </Link>{" "}
                в Нетворкинг
              </li>
              <li className="steps-netw__item">
                <span>Шаг 2:</span> Используйте фильтры для поиска интересующих
                Вас компаний и представителей
              </li>
              {netwDays.length ? (
                <li className="steps-netw__item">
                  <span>Шаг 3:</span> Начните общение с участниками выставки —
                  назначайте видео встречи и обменивайтесь визитками
                </li>
              ) : (
                <li className="steps-netw__item">
                  <span>Шаг 3:</span> Обменяйтесь контактами — онлайн-визитками.
                </li>
              )}
            </ul>
            <Link
              className="btn btn--medium btn--blue"
              to="/auth/signup"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            >
              Регистрация
            </Link>
          </div>
        </div>
        <div className="col-right">
          {renderDesc()}
          <img src={require("@public/images/netw-how-to-use.png")} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HowToUseNoAuth;
